import TrandingGrid from "@modules/skeleton/tranding_blog";
import { useGetTrandingBlogQuery } from "@redux/blog/blogApi/blogApi";
import API from "@unisearch/helpers/api";
import { Fragment, useEffect, useState } from "react";
import CategoryBox from "../components/blog_category_box";
import styles from "./blog_trending.module.scss";

export const BlogTrending = () => {
  const { data, isLoading: loading } = useGetTrandingBlogQuery();
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setPosts(data?.data);
  }, [data]);

  let content;
  if (loading) {
    <TrandingGrid />;
  }
  if (!loading && error) {
    content = { error };
  }
  if (!loading && !error) {
    content = (
      <Fragment>
        {posts?.length > 0 ? (
          <div className={styles.tranding_topic_wrapper}>
            {" "}
            {posts?.slice(0, 6).map((post, i) => (
              <CategoryBox key={i} post={post} />
            ))}
          </div>
        ) : (
          <>Data not found</>
        )}
      </Fragment>
    );
  }
  return (
    <Fragment>
      <section className={styles.section_trending}>
        <div className={styles.small_background}></div>
        <div className="container">
          <div className={styles.wrapper}>
            <h2 className={styles.sec_title}>Trending Topics</h2>
            {content}
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default BlogTrending;
